<section id="bestsellers" class="section products">
  <div class="container">
    <header class="products__head" appReveal>
      <div class="section-head">
        <p class="eyebrow">Handpicked for you</p>
        <h2 class="title">Our <em>Best Sellers</em></h2>
      </div>
      <a class="link-arrow" [href]="allHref" target="_blank" rel="noopener">
        View all living room recliners
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
      </a>
    </header>
  </div>

  <!-- a 4-up grid on desktop; two across on tablets, one on phones -->
  <ul class="rail container">
    @for (p of products; track p.name; let i = $index) {
      <li class="product" [appReveal]="(i % 4) * 80">
        <a class="product__link" [href]="p.href" target="_blank" rel="noopener">
          <div class="product__front">
            <figure class="product__media">
              <img [src]="p.image" [alt]="p.name + ' recliner'" width="640" height="400" loading="lazy" decoding="async" />
              <span class="product__off">{{ p.off }}</span>
            </figure>
            <div class="product__foot">
              <h3 class="product__name">{{ p.name }}</h3>
              @if (p.rating; as rating) {
                <p class="rating">
                  <span class="rating__stars" aria-hidden="true">
                    @for (star of stars; track star) {
                      <svg viewBox="0 0 24 24" [class.is-on]="star <= rating.stars"><path d="m12 2.6 2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9z" /></svg>
                    }
                  </span>
                  <span class="rating__count">({{ rating.reviews }})</span>
                  <span class="sr-only">Rated {{ rating.stars }} out of 5 by {{ rating.reviews }} {{ rating.reviews === 1 ? 'customer' : 'customers' }}</span>
                </p>
              }
              <p class="product__blurb">{{ p.blurb }}</p>
              <p class="product__price">
                <strong>{{ p.price }}</strong>
                <s>{{ p.mrp }}</s>
              </p>
            </div>
            <!-- the corner cut out of the card, with the round arrow button in it -->
            <span class="product__bay" aria-hidden="true">
              <span class="product__go">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7M9 7h8v8" /></svg>
              </span>
            </span>
          </div>
        </a>
      </li>
    }
  </ul>
</section>
